<template>
  <div class="full">
    <video
      id="fullDis"
      width="1920"
      height="1080"
      class="vdo"
      autoplay
      @click="showme()"
    ></video>
    <div class="fullbg_top"></div>
    <div class="fullbg_left"></div>
    <div class="fullbg_right"></div>
    <div class="headerbg">
      <div class="headerbar">
        <ul class="menu">
          <li style="margin-left: 50px">
            <image
              src="../assets/images/ta/ta-topButton-hover.png"
              style="position: absolute; left: 600px; top: 100px; z-index: 1"
            /><span>环境监测</span>
          </li>
          <li>
            <span>风机系统</span>
          </li>
          <li>
            <span>无烟安装</span>
          </li>
          <li>
            <span>化产系统</span>
          </li>
          <li>
            <span>鼓冷系统</span>
          </li>
          <li>
            <span>气体报警</span>
          </li>
          <li>
            <span>人员定位</span>
          </li>
          <li>
            <span>SIS系统</span>
          </li>
          <li>
            <span>电厂系统</span>
          </li>
        </ul>
        <div class="weather">
          <table>
            <tr>
              <td>
                <span class="time">{{ sysTimes.time }}</span>
              </td>
              <td>
                <div class="week">{{ sysTimes.week }}</div>
                <div class="date">{{ sysTimes.date }}</div>
              </td>
            </tr>
            <tr>
              <td>
                <img
                  src="../assets/images/ta/ta-topWeather.png"
                  align="absmiddle"
                />
                <span class="temp">16&#176;</span>
              </td>
              <td>
                <img
                  src="../assets/images/ta/ta-topHumidity.png"
                  align="absmiddle"
                />
                <span class="temp">空气:优</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div class="leftbar"></div>
    <div class="rightbar"></div>
    <div class="leftbox"></div>
    <div class="rightbox"></div>

    <div class="lefttop">
      <img src="../assets/images/ta/neiye/ta-ny-leftTitleBg01.png" />
      <div class="lt_1">
        <img src="../assets/images/ta/neiye/p1.png" align="absmiddle" />
        <span class="lt_1_t">排放口名称:{{ pfkInfo.name }}</span>
      </div>
      <div class="lt_1" style="margin-top: 15px">
        <img src="../assets/images/ta/neiye/p2.png" align="absmiddle" />
        <span class="lt_1_t">排放口编号:{{ pfkInfo.no }}</span>
      </div>
    </div>
    <div class="leftdown">
      <img src="../assets/images/ta/neiye/ta-ny-leftTitleBg02.png" />
      <div class="down_con">
        <div class="down_t" style="height: 200px">
          <table style="margin: 0 auto; width: 100%; text-align: center">
            <tr>
              <td>
                <img
                  src="../assets/images/ta/neiye/ta-ny-leftTitle02eryanghualiu03.png"
                />
              </td>
              <td>
                <img
                  src="../assets/images/ta/neiye/ta-ny-leftTitle02keliwu03.png"
                />
              </td>
            </tr>
            <tr>
              <td>
                <span class="fwtitle">二氧化硫</span>
              </td>
              <td>
                <span class="fwtitle">颗粒物</span>
              </td>
            </tr>
            <tr>
              <td>
                <span class="fwvalue">&lt;</span>
                <span class="fwvalue">70</span
                ><span class="fwunit">mg/m^3</span>
              </td>
              <td>
                <span class="fwvalue">&lt;</span>
                <span class="fwvalue">30</span
                ><span class="fwunit">mg/m^3</span>
              </td>
            </tr>
          </table>
        </div>
        <div class="down_t" style="height: 240px; margin: 0 auto">
          <table
            style="
              margin: 0 auto;
              background: rgba(139, 213, 255, 0.15);
              width: 100%;
              text-align: center;
            "
          >
            <tr>
              <td>
                <img
                  src="../assets/images/ta/neiye/ta-ny-leftTitle02keliwu02.png"
                  class="icon"
                  align="absmiddle"
                />
              </td>
              <td>
                <span class="title">颗粒物</span>
              </td>
              <td>
                <span class="num" style="color: #0ee79c">30</span>
              </td>
              <td>
                <span class="punit">mg/m^3</span>
              </td>
            </tr>
            <tr>
              <td>
                <img
                  src="../assets/images/ta/neiye/ta-ny-leftTitle02erynaghualiu02.png"
                  class="icon"
                  align="absmiddle"
                />
              </td>
              <td>
                <span class="title">二氧化硫</span>
              </td>
              <td>
                <span class="num" style="color: #ff5c5f">70</span>
              </td>
              <td>
                <span class="punit">mg/m^3</span>
              </td>
            </tr>
            <tr>
              <td>
                <img
                  src="../assets/images/ta/neiye/ta-ny-leftTitle02liuliang.png"
                  class="icon"
                  align="absmiddle"
                />
              </td>
              <td>
                <span class="title">流量</span>
              </td>
              <td>
                <span class="num" style="color: #0ee79c">30</span>
              </td>
              <td>
                <span class="punit">m^3/s</span>
              </td>
            </tr>
            <tr>
              <td>
                <img
                  src="../assets/images/ta/neiye/ta-ny-leftTitle02yanghanliang.png"
                  class="icon"
                  align="absmiddle"
                />
              </td>
              <td>
                <span class="title">氧含量</span>
              </td>
              <td>
                <span class="num" style="color: #0ee79c">30</span>
              </td>
              <td>
                <span class="punit">%</span>
              </td>
            </tr>
          </table>
        </div>
        <div class="down_t" style="height: 200px; margin: 0 auto">
          <table
            style="
              margin: 0 auto;
              width: 100%;
              text-align: center;
              margin-top: 20px;
            "
          >
            <tr>
              <td width="30%">
                <img
                  src="../assets/images/ta/neiye/ta-ny-leftTitle02green.png"
                  align="absmiddle"
                />
              </td>
              <td width="25%">
                <span class="green">绿色</span>
              </td>
              <td width="45%">
                <span class="sm">低于限值的80％</span>
              </td>
            </tr>
            <tr>
              <td>
                <img
                  src="../assets/images/ta/neiye/ta-ny-leftTitle02yellow.png"
                  align="absmiddle"
                />
              </td>
              <td>
                <span class="green">黄色</span>
              </td>
              <td>
                <span class="sm">限值的80-90％</span>
              </td>
            </tr>
            <tr>
              <td>
                <img
                  src="../assets/images/ta/neiye/ta-ny-leftTitle02orange.png"
                  align="absmiddle"
                />
              </td>
              <td>
                <span class="orange">橙色</span>
              </td>
              <td>
                <span class="sm">限值的90-100％</span>
              </td>
            </tr>
            <tr>
              <td>
                <img
                  src="../assets/images/ta/neiye/ta-ny-leftTitle02red.png"
                  align="absmiddle"
                />
              </td>
              <td>
                <span class="red">红色</span>
              </td>
              <td>
                <span class="sm">达到或超过限值</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="righttop">
      <img src="../assets/images/ta/neiye/ta-ny-rightTitleBg01.png" />
      <div class="com_d">
        <span>{{ deviceInfo.cmpname }}</span>
      </div>
      <div class="com_d" style="background: rgba(139, 213, 255, 0.1)">
        <span>{{ deviceInfo.devicecate }}</span>
      </div>
      <div class="com_d">
        <span>{{ deviceInfo.factoryNo }}</span>
      </div>
      <div class="com_d" style="background: rgba(139, 213, 255, 0.1)">
        <span>{{ deviceInfo.manufacted }}</span>
      </div>
      <div class="com_d">
        <span>{{ deviceInfo.yunweicmp }}</span>
      </div>
    </div>
    <div class="rightdown">
      <img src="../assets/images/ta/neiye/ta-ny-rightTitleBg02.png" />
      <div class="com_d">
        <span>{{ hbDevice.cont1 }}</span>
      </div>
      <div class="com_d" style="background: rgba(139, 213, 255, 0.1)">
        <span>{{ hbDevice.cont2 }}</span>
      </div>
      <div class="com_d">
        <span>{{ hbDevice.cont2 }}</span>
      </div>
    </div>

    <div class="goback">
      <img src="../assets/images/ta/neiye/goback.png" @click="goback()" />
    </div>
  </div>
</template>

<!--script src="../assets/js/mqttws31.min.js"></script-->
<script>
import axios from "axios";
import _global from "../components/Global.vue";
import { InitClientSocket } from "kd-api-project/lib";
import { Camera } from "kd-api-project/lib";
import { Paho } from "../assets/js/mqttws31.min";
const echarts = require("echarts");





export default {
  data() {
    return {
      currentFact: "一分厂装煤",
      zztdataoption: {
        //backgroundColor: "#111c4e",
        color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line",
            lineStyle: {
              opacity: 0,
            },
          },
          // formatter: function (prams) {
          //   return "办理数：" + prams[0].data;
          // },
        },
        grid: {
          left: "0%",
          right: "0%",
          bottom: "5%",
          top: "7%",
          height: "85%",
          containLabel: true,
          z: 22,
        },
        xAxis: [
          {
            type: "category",
            gridIndex: 0,
            data: [
              "01",
              "02",
              "03",
              "04",
              "05",
              "06",
              "07",
              "08",
              "09",
              "10",
              "11",
              "12",
            ],
            axisTick: {
              alignWithLabel: true,
            },
            axisLine: {
              lineStyle: {
                color: "#0c3b71",
              },
            },
            axisLabel: {
              show: true,
              color: "rgb(170,170,170)",
              fontSize: 10,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            gridIndex: 0,
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "#0c3b71",
              },
            },
            axisLabel: {
              color: "rgb(170,170,170)",
              formatter: "{value}",
            },
          },
          {
            type: "value",
            gridIndex: 0,
            splitNumber: 12,
            splitLine: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            splitArea: {
              show: true,
              areaStyle: {
                color: ["rgba(250,250,250,0.0)", "rgba(250,250,250,0.05)"],
              },
            },
          },
        ],
        series: [
          {
            name: "事件",
            type: "bar",
            barWidth: "30%",
            xAxisIndex: 0,
            yAxisIndex: 0,
            label: {
              normal: {
                //show: true,
                position: "top",
                textStyle: {
                  color: "#ffc72b",
                  fontSize: 20,
                },
              },
            },
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#00feff",
                  },
                  {
                    offset: 0.5,
                    color: "#027eff",
                  },
                  {
                    offset: 1,
                    color: "#0286ff",
                  },
                ]),
              },
            },
            data: [5, 10, 8, 15, 2, 10, 16, 5, 8, 14, 6, 18],
            zlevel: 11,
          },
          {
            name: "事件",
            type: "bar",
            barWidth: "50%",
            xAxisIndex: 0,
            yAxisIndex: 1,
            barGap: "-135%",
            data: [20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20],
            itemStyle: {
              normal: {
                color: "rgba(255,255,255,0.1)",
              },
            },
            zlevel: 9,
          },
        ],
      },
      sysTimes: {
        week: "",
        date: "",
        time: "",
      },
      pfkInfo: {
        name: "一分厂装煤",
        no: "DA015",
      },
      deviceInfo: {
        cmpname: "铜陵蓝光电子科技有限公司",
        devicecate: "设备型号:TLG-300",
        factoryNo: "出厂编号：YQ210401033",
        manufacted: "生产日期:2022.1.19",
        yunweicmp: "运维单位:利源",
      },
      hbDevice: {
        cont1: "地面除尘站",
        cont2: "治理工艺:半干法钙基脱硫+除尘",
        cont3: "运营状态:正常",
      },
    };
  },
  methods: {
    goback() {
      this.$router.push({ path: "/" });
    },
    showzzt() {
      let charts = echarts.init(document.getElementById("eventalertnum"));
      charts.setOption(this.zztdataoption);
    },
    showTime() {
      setInterval(() => {
        var dt = _global.getCurrentTime();
        this.sysTimes.week = dt.week;
        this.sysTimes.time = dt.time;
        this.sysTimes.date = dt.date;
      }, 1000);
    },
    websocketConn() {
      var client = new Paho.MQTT.Client(hostname, port, clientId);
      //注册连接断开处理事件
      client.onConnectionLost = onConnectionLost;
      //注册消息接收处理事件
      client.onMessageArrived = onMessageArrived;

      var options = {
        invocationContext: {
          host: hostname,
          port: port,
          path: client.path,
          clientId: clientId,
        },
        timeout: timeout,
        keepAliveInterval: keepAlive,
        cleanSession: cleanSession,
        useSSL: ssl,
        onSuccess: onConnect,
        onFailure: function (e) {
          if (typeof error[e.errorCode] == "undefined") {
            console.log("未知错误");
          } else {
            console.log(error[e.errorCode].text);
          }
        },
      };
      //连接服务器
      client.connect(options);

      //重新连接服务器
      function reConnect() {
        window.reConnecter = window.setInterval(function () {
          clientId =
            "client-" +
            Number(Math.random().toString().substr(2, 5) + Date.now()).toString(
              36
            );
          options = null;
          client = null;
          client = new Paho.MQTT.Client(hostname, port, clientId);
          options = {
            invocationContext: {
              host: hostname,
              port: port,
              path: client.path,
              clientId: clientId,
            },
            timeout: timeout,
            keepAliveInterval: keepAlive,
            cleanSession: cleanSession,
            useSSL: ssl,
            onSuccess: onConnect,
          };
          //注册连接断开处理事件
          client.onConnectionLost = onConnectionLost;
          //注册消息接收处理事件
          client.onMessageArrived = onMessageArrived;
          //连接服务器
          client.connect(options);
        }, reConnectTimeout * 1000);
      }

      //连接成功处理事件
      function onConnect() {
        //console.log("onConnected");
        window.clearInterval(window.reConnecter);
        client.subscribe(topic);
      }
      //断开连接处理事件
      function onConnectionLost(e) {
        if (typeof error[e.errorCode] == "undefined") {
          console.log("未知错误");
        } else {
          console.log(error[e.errorCode].text);
        }

        window.clearInterval(window.reConnecter);
        reConnect();
      }
      //接收数据处理事件
      function onMessageArrived(mes) {
        // {"device_name":"二分厂干熄焦","device_code":"DA028","last_time":"2022-02-16 09:19:00","items":[{"name":"标态流量","field":"B02-Rtd","value":"26.19"},{"name":"烟气温度","field":"S03-Rtd","value":"26.39"},{"name":"烟气压力","field":"S08-Rtd","value":"-0.12"},{"name":"烟气流速","field":"S02-Rtd","value":"6.58"},{"name":"烟气湿度","field":"S05-Rtd","value":"2.9"},{"name":"氧气含量","field":"S01-Rtd","value":"18.42"},{"name":"烟尘","field":"01-Rtd","value":"18.42"},{"name":"二氧化硫","field":"02-Rtd","value":"26.19"}]}
        console.log("收到消息:" + mes);
        var message = JSON.parse(mes);

        //循环解析
        for (var i = 0; i < message.length; i++) {
          if (message[i].device_name === this.currentFact) {
            this.pfkInfo.name = message[i].device_name;
            this.pfkInfo.no = message[i].device_code;
            if (message[i].item.length > 0) {
              for (var a = 0; a < message[i].item.length; a++) {
                switch (message[i].item[a]) {
                  case "烟气温度":
                    var title = message[i].item[a].name;
                    var field = message[i].item[a].field;
                    var value = message[i].item[a].value;
                    break;
                    case "烟气温度":
                    var title = message[i].item[a].name;
                    var field = message[i].item[a].field;
                    var value = message[i].item[a].value;
                    break;
                }
              }
            }
          }
        }
      }
    },
    getDots() {
      //加载场景即可
      InitClientSocket.init(
        "fullDis",
        "ws://58.213.192.217:40968/2",
        "1920*1080"
      )
        .then(() => {})
        .catch((err) => {
          console.error(err);
        });
    },
    getParam() {
      this.currentFact = this.$route.params.name;
      console.log(this.currentFact);
    },
  },
  mounted() {
    this.showTime();
    this.getParam();
    this.websocketConn();
    this.getDots();
  },
};
</script>

<style lang="scss" scoped>
.full {
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  width: 1920px;
  height: 1080px;
  overflow: none;
  overflow-x: hidden;
  z-index: 1;
}

.fullbg_top {
  position: absolute;
  top: 0;
  left: 0;
  width: 1920px;
  height: 158px;
  background: url(../assets/images/ta/ta-Bg1.png) no-repeat;
  opacity: 0.1;
}

.fullbg_left {
  position: absolute;
  top: 158px;
  left: 0px;
  width: 418px;
  height: 938px;
  background: url(../assets/images/ta/ta-Bg2.png) no-repeat;
  opacity: 0.1;
}

.fullbg_right {
  position: absolute;
  top: 158px;
  left: 1502px;
  width: 418px;
  height: 938px;
  background: url(../assets/images/ta/ta-Bg2.png) no-repeat;
  opacity: 0.1;
}

.vdo {
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
}

.headerbg {
  position: absolute;
  top: 0px;
  width: 1920px;
  height: 154px;
  background: url(../assets/images/ta/ta-topShadow.png) no-repeat;
}

.headerbar {
  width: 1970px;
  height: 146px;
  position: absolute;
  top: 4px;
  left: -20px;
  background: url(../assets/images/ta/ta-topMenu.png) no-repeat;
  z-index: 3;
}
.menu {
  position: absolute;
  top: 0px;
  left: 530px;
  top: 47px;
  //z-index: 4;
}

.pri {
  background-image: url(../assets/images/ta/ta-topButton-hover.png);
}

.menu li {
  display: inline-block;
  margin-left: 20px;
  cursor: pointer;
}

.menu li span {
  font-size: 26px;
  font-family: YouSheBiaoTiHei;
  color: rgba(74, 81, 86, 0.8);
  line-height: 34px;
  background: linear-gradient(
    180deg,
    #02fafa 0%,
    #ffffff 53%,
    rgba(255, 255, 255, 0.94) 68%,
    rgba(2, 250, 250, 0.8) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.weather {
  position: absolute;
  left: 1721px;
  top: 18px;
}

.time {
  width: 96px;
  height: 34px;
  font-size: 34px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #eff9ff;
  line-height: 34px;
  letter-spacing: 1px;
}

.week {
  width: 45px;
  height: 15px;
  font-size: 15px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #eff9ff;
  line-height: 22px;
}

.date {
  margin-top: 5px;
  width: 76px;
  height: 15px;
  font-size: 15px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #eff9ff;
  line-height: 22px;
}

.temp {
  width: 25px;
  height: 16px;
  font-size: 16px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #eff9ff;
  line-height: 24px;
}

.leftbar {
  z-index: 3;
  position: absolute;
  top: 133px;
  left: 0px;
  width: 17px;
  height: 918px;
  background: url(../assets/images/ta/ta-leftBorder.png) no-repeat;
}

.rightbar {
  position: absolute;
  z-index: 4;
  top: 133px;
  right: 0px;
  width: 17px;
  height: 918px;
  background: url(../assets/images/ta/ta-rightBorder.png) no-repeat;
}

.leftbox {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 463px;
  height: 1080px;
  background: url(../assets/images/ta/ta-leftShadow.png) no-repeat;
  //z-index: 1;
}

.rightbox {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 463px;
  height: 1080px;
  background: url(../assets/images/ta/ta-rightShadow.png) no-repeat;
  //z-index: 1;
}

.lefttop {
  position: absolute;
  left: 41px;
  top: 133px;
  width: 376px;
  height: 168px;
  background: url(../assets/images/ta/neiye/ta-ny-leftTitleBg01_1.png) no-repeat;
  //z-index: 3;
}

.lt_1 {
  width: 80%;
  margin: 0 auto;
}

.lt_1_t {
  margin-left: 10px;
  width: 220px;
  height: 20px;
  font-size: 20px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: rgba(239, 249, 255, 0.9);
  line-height: 30px;
}

.leftdown {
  position: absolute;
  left: 41px;
  top: 333px;
  width: 376px;
  height: 695px;
  background: url(../assets/images/ta/neiye/ta-ny-leftTitleBg02_1.png) no-repeat;
  //z-index: 3;
}

.down_con {
  width: 90%;
  margin: 0 auto;
}

.righttop {
  position: absolute;
  left: 1500px;
  top: 133px;
  width: 376px;
  height: 362px;
  background: url(../assets/images/ta/neiye/ta-ny-rightTitleBg01_1.png)
    no-repeat;

  //z-index: 3;
}

.com_d {
  width: 100%;
  margin: 0 auto;
  height: 60px;
  font-size: 20px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: rgba(239, 249, 255, 0.9);
  line-height: 60px;
}

.com_d span {
  margin-left: 30px;
  line-height: 60px;
}

.goback {
  position: absolute;
  left: 864px;
  top: 992px;
  width: 192px;
  height: 56px;
  z-index: 10;
  //border: 1px solid red;
}

.rightdown {
  position: absolute;
  left: 1500px;
  top: 526px;
  width: 376px;
  height: 248px;
  background: url(../assets/images/ta/neiye/ta-ny-rightTitleBg02_1.png)
    no-repeat;
  //z-index: 3;
}

///////////////////////////////////////////////////////////////////////
.lefttopblock {
  position: absolute;
  left: 41px;
  top: 133px;
  width: 379px;
  height: 218px;
  background: url(../assets/images/ta/ta-hj-leftTitleBg01.png) no-repeat;
}

.lefttop1_1 {
  position: absolute;
  left: 75px;
  top: 54px;
  width: 226px;
  height: 117px;
  font-size: 26px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: rgba(239, 249, 255, 0.9);
  line-height: 39px;
}

.leftmiddleblock {
  position: absolute;
  left: 41px;
  top: 381px;
  width: 376px;
  height: 372px;
  background: url(../assets/images/ta/ta-hj-leftTitleBg02.png) no-repeat;
}

.yuangong {
  width: 90%;
  text-align: center;
  margin: 0 auto;
}

.yg {
  height: 80px;
}

.num {
  font-size: 40px;
  font-family: YouSheBiaoTiHei;
  color: #429dff;
}

.title {
  font-size: 20px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 40;
  color: #eff9ff;
  // background:green;
  margin-top: -190px;
}

.ygimg {
  width: 94px;
  height: 124px;
  background: green;
  background: url(../assets/images/ta/ta-hj-leftTitle03pinBg.png) no-repeat;
}

.yginfo {
  font-size: 20px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #eff9ff;
  line-height: 30px;
  margin-left: 20px;
}

.leftdownblock {
  position: absolute;
  left: 41px;
  top: 786px;
  width: 376px;
  height: 240px;
  background: url(../assets/images/ta/ta-hj-leftTitleBg03.png) no-repeat;
}

.punit {
  width: 60px;
  height: 20px;
  font-size: 20px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #eff9ff;
  line-height: 30px;
  text-align: left;
}

.down_t .icon {
  margin-left: 10px;
}

.eventalertnum {
  width: 90%;
  height: 150px;
  margin: 0 auto;
  margin-top: 10px;
}

.righttopblock {
  position: absolute;
  left: 1500px;
  top: 133px;
  width: 376px;
  height: 620px;
  background: url(../assets/images/ta/ta-hj-rightTitleBg01.png) no-repeat;
  margin: 0 auto;
}

.righttopblock div {
  margin: 0 auto;
  margin-top: 20px;
  width: 288px;
  font-size: 22px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: rgba(239, 249, 255, 0.9);
  line-height: 34px;
  letter-spacing: 0.01em;
}

.rightdownblock {
  position: absolute;
  left: 1500px;
  top: 788px;
  width: 376px;
  height: 240px;
  background: url(../assets/images/ta/ta-hj-rightTitleBg02.png) no-repeat;
}

.rightData {
  width: 90%;
  margin: 0 auto;
}

.rightData ul li {
  list-style-type: none;
}

.rightnum {
  width: 380px;
  height: 47px;
  font-size: 36px;
  font-family: YouSheBiaoTiHei;
  color: #429dff;
  line-height: 47px;
  text-align: right;
}

.righttt {
  width: 80px;
  height: 16px;
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #c3e8ff;
  line-height: 24px;
}

.rightunit {
  width: 40px;
  font-size: 10px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #c3e8ff;
  line-height: 10px;
}

.green {
  width: 47px;
  height: 24px;
  font-size: 24px;
  font-family: PangMenZhengDao;
  color: #0ee79c;
  line-height: 27px;
  font-weight: 100;
}

.yellow {
  width: 45px;
  height: 24px;
  font-size: 24px;
  font-family: PangMenZhengDao;
  color: #ffc100;
  line-height: 27px;
  font-weight: 100;
}

.orange {
  width: 45px;
  height: 24px;
  font-size: 24px;
  font-family: PangMenZhengDao;
  color: #ff7a27;
  line-height: 27px;
  font-weight: 100;
}

.red {
  width: 47px;
  height: 24px;
  font-size: 24px;
  font-family: PangMenZhengDao;
  color: #ff4d4d;
  line-height: 27px;
  font-weight: 100;
}

.sm {
  width: 128px;
  height: 18px;
  font-size: 18px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #c3e8ff;
  line-height: 27px;
}

.fwtitle {
  width: 111px;
  height: 39px;
  font-size: 30px;
  font-family: YouSheBiaoTiHei;
  font-weight: 100;
  color: #eff9ff;
  opacity: 1;
  line-height: 39px;
  text-shadow: 0px 0px 6px rgba(255, 255, 255, 0.1);
}

.fwvalue {
  font-weight: 100;
  width: 66px;
  height: 39px;
  font-size: 30px;
  font-family: YouSheBiaoTiHei;
  color: #429dff;
  line-height: 39px;
}

.fwunit {
  width: 64px;
  height: 16px;
  font-size: 16px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #eff9ff;
  line-height: 16px;
}
</style>